import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

import getConfig from '../../../util/config';
import { getAccountProfileName } from '../views/UserPage/helpers';
import { getThumbBySize } from '../../../util/photo';
import { IMAGE_SIZE_CODE } from '../../../constants/image-size-codes';
import { ALBUM_PRIVACY } from '../../../constants/albums';

const propTypes = {
  album: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    hero_image: PropTypes.shape({
      url: PropTypes.string,
    }),
    root_album_folder: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      hero_image: PropTypes.shape({
        id: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
      }),
    }).isRequired,
    creator: PropTypes.shape({
      id: PropTypes.string.isRequired,
      organization_name: PropTypes.string,
      hero_image: PropTypes.shape({
        id: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
      }),
    }).isRequired,
  }).isRequired,
};

const WebGalleryAlbumMeta = ({ album }) => {
  const {
    app: { pageUrl },
  } = getConfig();
  const { creator: account } = album;
  const heroImage =
    album.root_album_folder.hero_image?.url ?? account.hero_image?.url;
  const coverPhotoUrl = getThumbBySize(
    album.cover_photo?.thumbnail_urls,
    IMAGE_SIZE_CODE.MEDIUM2X,
  )?.url;
  const title = `${album.name} - ${getAccountProfileName(
    account,
  )} - Waldo Photos`;
  const description = `Browse all photos of ${
    album.name
  } by ${getAccountProfileName(account)} for free!`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:url" content={pageUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      {(heroImage || coverPhotoUrl) && (
        <meta property="og:image" content={heroImage || coverPhotoUrl} />
      )}
      {album?.privacy === ALBUM_PRIVACY.PRIVATE && (
        <meta name="robots" content="noindex" />
      )}
    </Helmet>
  );
};

WebGalleryAlbumMeta.propTypes = propTypes;

export default WebGalleryAlbumMeta;
